// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"fc8f104d","301":"fea3d613","838":"ec90abf4"}[chunkId] + ".chunk.js";
};